// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3KvaZ","buttons":"Footer_buttons__1ddBK"};